import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { TechDocsGenerationStatus } from 'shared-react';

const generationStatus = AddonBlueprint.make({
  name: 'generation-status',
  params: {
    name: 'generation-status',
    location: 'Subheader',
    component: TechDocsGenerationStatus,
  },
});

export const techdocsGenerationStatusModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [generationStatus],
});
